<template>
  <header-layout />
  <auth-view
    title="Log in"
    mode="login"
  />
  <div class="_bottom">
    Don't have an account yet? <router-link
      class="-underline"
      :to="{ name: $routes.register }"
    >
      Sign up here
    </router-link>
  </div>
</template>

<script>
import AuthView from 'shared/components/AuthView.vue';
import HeaderLayout from 'shared/components/HeaderLayout.vue';

export default {
  name: 'LoginView',
  components: { HeaderLayout, AuthView },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

  ._bottom {
    text-align: center;
    color: map_get($grey, 'lighten-1');
  }
</style>
